module.exports = {
   components: [],
   routes: [],
   sub_routes: [{
      name: "UserTrash",
      path: "trash/user_trash",
      component: () => import('./user_trash/user_trash.vue'),
   }, ]
}